<template>
    <div v-if="value">
        <van-popup v-model="visible" position="center" :closeOnClickOverlay="closeOnClickOverlay" :round="round"
            :position="position" :style="popupStyle" @close="closePopup">
            <!-- 顶部标题 -->
            <div v-if="titleShow" class="popup-title">
                <div class="popup-title-text" :style="{ textAlign: textAlign }">{{ title }}</div>
                <!-- 关闭按钮 -->
                <div v-if="closeIconShow && textAlign != 'right'" class="popup-close-btn" @click="closePopup">
                    <van-icon name="cross" size="1.2rem" color="#666" />
                </div>
            </div>

            <!-- 内容区域 -->
            <div class="popup-content">
                <slot></slot>
            </div>

            <!-- 底部按钮 -->
            <div class="popup-footer" v-if="btnShow">
                <TianshengButton v-if="closeBtnshow" :style="closeBtnStyle" :customStyle="closeBtnCustomStyle"
                    type="primary" :text="closeBtnText" @click="closePopup">
                    {{ closeBtnText }}
                </TianshengButton>
                <div v-if="confirmBtnShow && closeBtnshow" class="popusBr"></div>
                <TianshengButton v-if="confirmBtnShow" :style="confirmBtnStyle" :loading="confirmBtnloading"
                    :text="$t(confirmBtnText)" :customStyle="confirmBtnCustomStyle" type="primary" @click="confirm">
                    {{ $t(confirmBtnText) }}
                </TianshengButton>
            </div>
        </van-popup>
    </div>
</template>

<script>

export default {
    name: 'ComPopup',
    props: {
        // 弹窗是否展示
        value: {
            type: Boolean,
            default: false
        },
        // 弹窗位置
        position: {
            type: String,
            default: 'center'
        },
        // 弹窗是否圆角
        round: {
            type: Boolean,
            default: true
        },
        // 点击 遮罩 是否关闭弹窗
        closeOnClickOverlay: {
            type: Boolean,
            default: false,
        },
        // 弹窗背景颜色
        popupBgcolor: {
            type: String,
            default: '#fff'
        },
        // 弹窗宽度
        popupWidth: {
            type: String,
            default: '85%'
        },
        // 弹窗高度
        popupHeight: {
            type: String,
            default: '30%'
        },
        // 是否现实关闭图标
        closeIconShow: {
            type: Boolean,
            default: true
        },
        // 标题
        title: {
            type: String,
            default: '标题'
        },
        // 标题是否展示
        titleShow: {
            type: Boolean,
            default: true
        },

        // 标题是位置
        textAlign: {
            type: String,
            default: 'left'
        },
        // 弹窗是否展示按钮
        btnShow: {
            type: Boolean,
            default: true
        },
        // 关闭按钮是否展示
        closeBtnshow: {
            type: Boolean,
            default: true
        },
        // 关闭按钮文本
        closeBtnText: {
            type: String,
            default: '关闭'
        },
        // 关闭按钮背景颜色
        closeBtnBgcolor: {
            type: String,
            default: '#fff'
        },
        // 关闭按钮字体颜色
        closeBtnTextcolor: {
            type: String,
            default: '#000'
        },
        // 确认按钮是否展示
        confirmBtnShow: {
            type: Boolean,
            default: true
        },
        // 确认按钮文本
        confirmBtnText: {
            type: String,
            default: '确定'
        },
        // 确认按钮背景颜色
        confirmBtnBgcolor: {
            type: String,
            default: ''
        },
        // 确认按钮字体颜色
        confirmBtnTextcolor: {
            type: String,
            default: ''
        },
        // 确认按钮是否展示loading
        confirmBtnloading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            visible: this.value,
        }
    },
    watch: {
        value(val) {
            this.visible = val
        },
        // visible(val) {
        //     console.log(val);
        //     this.$emit('input', val);
        // },
    },
    computed: {
        popupStyle() {
            return {
                width: this.position == 'center' ? this.popupWidth : "",
                height: this.position == 'left' || this.position == 'right' ? "" : this.popupHeight,
                backgroundColor: this.popupBgcolor,
                display: 'flex',
                flexDirection: 'column',
            }
        },
        closeBtnStyle() {
            return {
                width: this.confirmBtnShow ? '49.75%' : '95%',
                height: '3rem',
            }
        },
        closeBtnCustomStyle() {
            return {
                color: this.closeBtnTextcolor || 'var(--main-color)',
                background: this.closeBtnBgcolor || 'var(--main-bgcolor)',
                border: 'none',
            }
        },
        confirmBtnStyle() {
            return {
                width: this.closeBtnshow ? '49.75%' : '95%',
                height: '3rem',
            }
        },
        confirmBtnCustomStyle() {
            return {
                color: this.confirmBtnTextcolor || 'var(--main-color)',
                background: this.confirmBtnBgcolor || 'var(--main-bgcolor)',
                border: 'none',
            }
        },
    },
    methods: {
        closePopup() {
            this.visible = false; // 会触发 watch，父组件的 show 同步变 false
            this.$emit('input', this.visible );
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm')
            // 默认关闭弹窗，若需要自定义关闭逻辑，父组件监听confirm事件自行控制
        },
    },
}
</script>
<style lang="scss">
@import "./index.scss"; // 引入按钮样式文件</style>
<style scoped>
.popup-title {
    position: relative;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    flex-shrink: 0;
}

.popup-title-text {
    font-size: 1.2rem;
    font-weight: bold;
    color: #FFF;
    flex: 1;
}

.popup-close-btn {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    padding: 0.25rem;
    border-radius: 50%;
    transition: background-color 0.2s;
}

.popup-close-btn:hover {
    background-color: #f5f5f5;
}

.popup-content {
    flex: 1;
    overflow-y: auto;

}

.default-content {
    text-align: center;
    color: #666;
    font-size: 1rem;
    padding: 1rem 0;
}

.popup-footer {
    width: 100%;
    border-top: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    padding-top: 0.15rem;
    flex-shrink: 0;
    justify-content: center;
    margin-bottom: 0.5rem;
}

.popusBr {
    width: 0.5%;
    height: 100%;
    background-color: #f0f0f0;
}
</style>